<template>
<div class="main-menu menu-fixed menu-light menu-accordion menu-shadow" data-scroll-to-active="true" style="margin-top:65px !important;">
    <div class="main-menu-content">        
        <ul v-if="controlTowerUsers.includes(useremail)" class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation ">
             <!-- <li class="nav-item has-sub"> -->
                <!-- <a href="#/vehicle-tracking" aria-current="page" class="d-flex align-items-center first_a">
                    <em  class="custom-class i_icon_st la-map las lab"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Fleet Management</span>
                </a>   -->
                <!-- <ul class="menu-content sub-menu"> -->
                    <!-- <li class="nav-item">
                        <router-link to='/vehicle/scheduling' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Vehicle Scheduling</span>
                    </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/vehicle-tracking' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Live Vehicle Tracking </span>
                    </router-link>
                    </li>
                     <li class="nav-item">
                        <router-link to='/accident-management' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics"> Accident Management </span>
                    </router-link>
                    </li>
                      <li class="nav-item">
                        <router-link to='/breakdown-management' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Breakdown Management </span>
                    </router-link>
                    </li> -->
                     <!-- <li class="nav-item">
                        <router-link to='/schedules/vehicle-calendar' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Vehicle Schedule </span></router-link>
                    </li>
                     <li class="nav-item">
                        <router-link to='/live/vehicle/routes' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics"> Vehicle Routes </span></router-link>
                    </li>

                    
                    <li class="nav-item">
                        <router-link to='/live/vehicle/map-cluster' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Live Vehicle Locations    </span></router-link>
                    </li> -->
                   
                <!-- </ul> -->
            <!-- </li> -->
             <!-- <li class="nav-item has-sub">
                <a href="#/calling-dashboard" aria-current="page" class="d-flex align-items-center first_a">
                     <em  class="custom-class i_icon_st la-rocket las lab"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Auto Bot Calling </span>
                </a>
                <ul class="menu-content sub-menu">
                    <li class="nav-item">
                        <router-link to='/calling-dashboard' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Bot Calling Dashboard </span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/escalation-configuration' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Escalation  TAT Configuration</span></router-link>
                    </li>
                </ul>
            </li> -->
            <!-- <li class="nav-item has-sub">
                <a href="#/support/tickets" aria-current="page" class="d-flex align-items-center first_a">
                    <em class="i_icon_st las la-ticket-alt"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Control Tower Tickets</span>
                </a>
                <ul class="menu-content sub-menu">
                   <li class="nav-item">
                        <router-link to='/support/tickets' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Ticket Management</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/support/tickets/add-ticket' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Create Tickets</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/support/tickets/add-ticket-configuration' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Ticket Configuration</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/support/tickets/add-ticket-roadster' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Ticket Roadster</span></router-link>
                    </li>
                </ul>
            </li> -->


            <!-- Newly up to date mcontrol tower menus -->

            <li class="nav-item nav-item2 active">
                <a href="#/mydashboard" aria-current="page" class="d-flex align-items-center">
                    <em class="las la-border-all"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Dashboard</span>
                </a>
            </li>
            <li class="nav-item nav-item2" >
                <a href="#/admin-panel" aria-current="page" class="d-flex align-items-center">
                    <em class="la la-user-shield las lab"></em>
                    <span class="menu-title text-truncate rolelistdd" >Admin Panel</span>
                </a>
            </li>
            <li class="nav-item has-sub" >
                <a href="#/mydashboard" aria-current="page" class="d-flex align-items-center first_a">
                    <em class="las la-truck-moving"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Vehicle Monitoring </span>
                </a>  
                <ul class="menu-content sub-menu">
                    <!-- <li class="nav-item">
                        <router-link to='/vehicle/scheduling' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Vehicle Scheduling</span>
                    </router-link>
                    </li> -->
                    <li class="nav-item" v-if="hasMenuPermission('Vehicle Tracking & Monitoring','/vehicle-tracking')">
                        <router-link to='/vehicle-tracking' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Live Vehicle Tracking </span>
                    </router-link>
                    </li>
                    <li class="nav-item"  v-if="hasMenuPermission('Vehicle Tracking & Monitoring','/accident-reports')">
                        <router-link to='/accident-reports' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Accident  Management</span>
                    </router-link>
                    </li>
                    <li class="nav-item"  v-if="hasMenuPermission('Vehicle Tracking & Monitoring','/breakdown-reports')">
                        <router-link to='/breakdown-reports' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Breakdown  Management</span>
                    </router-link>
                    </li>
                     <!-- <li class="nav-item">
                        <router-link to='/schedules/vehicle-calendar' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Vehicle Schedule </span></router-link>
                    </li> -->
                     <!-- <li class="nav-item">
                        <router-link to='/live/vehicle/routes' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics"> Vehicle Routes </span></router-link>
                    </li> -->

                    
                    <!-- <li class="nav-item">
                        <router-link to='/google-map' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Live Vehicle Locations    </span></router-link>
                    </li> -->
                   
                </ul>
            </li>
             <li class="nav-item has-sub" v-if="hasPermission('Auto Bot Calling')">
                <a href="#/mydashboard" aria-current="page" class="d-flex align-items-center first_a">
                    <em class="las la-phone-volume"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Auto Bot Calling </span>
                </a>
                <ul class="menu-content sub-menu">
                      <!-- <li class="nav-item">
                        <router-link to='/calling-dashboard' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Bot Calling Dashboard </span></router-link>
                    </li> -->
                     <!-- <li class="nav-item">
                        <router-link to='/mydashboard' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics"> Auto Bot Analysis </span></router-link>
                    </li> -->
                    <!-- <li class="nav-item" v-if="hasMenuPermission('Auto Bot Calling','/escalation/escalated-calls')">
                        <router-link to='/escalation/escalated-calls' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics"> Escalated Calls </span></router-link>
                    </li> -->
                   
                    <li class="nav-item" v-if="hasMenuPermission('Auto Bot Calling','/escalation/vehicle-geolocation')">
                        <router-link to='/escalation/vehicle-geolocation' class="d-flex align-items-center" >
                            <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Vehicle Geo Location </span>
                        </router-link>
                    </li>
                   
                </ul>
            </li>
            <li class="nav-item nav-item2" v-if="hasPermission('Tracking Dashboard')">
                <a href="#/tracking-dashboard" aria-current="page" class="d-flex align-items-center">
                    <em class="las la-signal"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Tracking Dashboard  </span>
                </a>
            </li>
            <li class="nav-item has-sub" v-if="hasPermission('Control Tower Tickets')">
                <a href="#/mydashboard" aria-current="page" class="d-flex align-items-center first_a">
                    <!-- <em class="i_icon_st la-signal las lab"></em> -->
                    <em class="las la-ticket-alt"></em>
                    
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Control Tower Tickets</span>
                </a>
                <ul class="menu-content sub-menu" >
                   <li class="nav-item" v-if="hasMenuPermission('Control Tower Tickets','/support/tickets')">
                        <router-link to='/support/tickets' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Ticket Management</span></router-link>
                    </li>
                    <li class="nav-item"  v-if="hasMenuPermission('Control Tower Tickets','/support/tickets/add-ticket')">
                        <router-link to='/support/tickets/add-ticket' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Create Tickets</span></router-link>
                    </li>
                    <li class="nav-item"  v-if="hasMenuPermission('Control Tower Tickets','/support/tickets/add-ticket-configuration')">
                        <router-link to='/support/tickets/add-ticket-configuration' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Ticket Configuration</span></router-link>
                    </li>
                    <li class="nav-item"  v-if="hasMenuPermission('Control Tower Tickets','/support/tickets/add-ticket-roadster')">
                        <router-link to='/support/tickets/add-ticket-roadster' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Ticket Roaster</span></router-link>
                    </li>
                </ul>
            </li>
            <li class="nav-item has-sub"  v-if="hasPermission('Reports')">
                <a href="#/support/tickets" aria-current="page" class="d-flex align-items-center first_a">
                    <em class="las la-digital-tachograph"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Reports</span>
                </a>
                <ul class="menu-content sub-menu">
                   <li class="nav-item" v-if="hasMenuPermission('Reports','/reports/routeperformance')">
                        <router-link to='/reports/routeperformance' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Route Performance</span></router-link>
                    </li>
<!--                     <li class="nav-item" v-if="hasMenuPermission('Reports','/reports/loading-unloading')">
                        <router-link to='/reports/loading-unloading' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Loading-Unloadig Delay</span></router-link>
                    </li> -->
                    <li class="nav-item" v-if="hasMenuPermission('Reports','/reports/enroutedelay')">
                        <router-link to='/reports/enroutedelay' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Enroute Touch Point Delay</span></router-link>
                    </li>
                    

                    <li class="nav-item" v-if="hasMenuPermission('Reports','/reports/accidentreport')">
                        <router-link to='/reports/accidentreport' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Accident</span></router-link>
                    </li>
                </ul>
            </li>

            <li class="nav-item has-sub"  v-if="hasPermission('Access Control')">
                <a href="#/" aria-current="page" class="d-flex align-items-center first_a">
                    <em class="las la-user-lock"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Access Control</span>
                </a>
                <ul class="menu-content sub-menu">
                   <li class="nav-item" v-if="hasMenuPermission('Access Control','/access-control')">
                        <router-link to='/access-control' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Permissions</span></router-link>
                    </li>
                    <li class="nav-item" v-if="hasMenuPermission('Access Control','/register')">
                        <router-link to='/register' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Register</span></router-link>
                    </li>
                </ul>
            </li>

        </ul>
        <ul v-else class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation ">
            <!-- <li v-bind:class="{'active':item.name+'-'+index ==currentindex,'nav-item':navFlag,'has-sub':item.children.length>0}"  v-bind:key="item.name" v-for="(item,index) in sidebarData" @click="getopenflag(item.name+'-'+index)" class="navbar_mobile ">
                <router-link v-bind:to="item.url" class="d-flex align-items-center " >
                    <component :is="item.icon" size="1.5x" class="custom-class"></component>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">{{item.name}}</span>
                </router-link>
                <ul class="menu-content " v-if="item.children">
                    <li  v-bind:key="submenu.url" v-for="submenu in item.children">
                        <router-link v-bind:to="submenu.url" class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">{{submenu.name}}</span></router-link>
                    </li>
                </ul>
            </li>  -->
            <li class="nav-item nav-item2 active">
                <a href="#/mydashboard" aria-current="page" class="d-flex align-items-center">
                    <i data-feather='home' class="i_icon_st la-clipboard-list las lab "></i>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Dashboard</span>
                </a>
            </li>
            <li class="nav-item nav-item2">
                <a href="#/master" aria-current="page" class="d-flex align-items-center">
                    <i data-feather='layers' class="i_icon_st la-clipboard-list las lab "></i>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Admin Panel</span>
                </a>
            </li>
            
            <li class="nav-item has-sub">
                <a href="#/mydashboard" aria-current="page" class="d-flex align-items-center first_a">
                    <em data-feather='airplay' class="custom-class feather feather-settings"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Entry & Loading Control</span>
                </a>
                <ul class="menu-content sub-menu">
                    <li class="nav-item">
                        <router-link to='/entry/gate-control' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Gate Control </span>
                    </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/entry/dock-control' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Dock Control </span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/entry/daily-transaction' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Daily Transaction  </span></router-link>
                    </li>
                </ul>
            </li>
             <li class="nav-item has-sub">
                <a href="#/mydashboard" aria-current="page" class="d-flex align-items-center first_a">
                    <em  class="custom-class i_icon_st la-map las lab"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Vehicle Tracking & Monitoring </span>
                </a>  
                <ul class="menu-content sub-menu">
                    <!-- <li class="nav-item">
                        <router-link to='/vehicle/scheduling' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Vehicle Scheduling</span>
                    </router-link>
                    </li> -->
                    <!-- <li class="nav-item">
                        <router-link to='/vehicle-tracking' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Live Vehicle Tracking </span>
                    </router-link>
                    </li> -->
                     <!-- <li class="nav-item">
                        <router-link to='/accident-management' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics"> Accident Management </span>
                    </router-link>
                    </li>
                      <li class="nav-item">
                        <router-link to='/breakdown-management' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Breakdown Management </span>
                    </router-link>
                    </li> -->
                     <li class="nav-item">
                        <router-link to='/schedules/vehicle-calendar' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Vehicle Schedule </span></router-link>
                    </li>
                     <li class="nav-item">
                        <router-link to='/live/vehicle/routes' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics"> Vehicle Routes </span></router-link>
                    </li>

                    
                    <!-- <li class="nav-item">
                        <router-link to='/google-map' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Live Vehicle Locations    </span></router-link>
                    </li> -->
                   
                </ul>
            </li>
             <!-- <li class="nav-item has-sub">
                <a href="#/mydashboard" aria-current="page" class="d-flex align-items-center first_a">
                     <em  class="custom-class i_icon_st la-rocket las lab"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Auto Bot Calling </span>
                </a>
                <ul class="menu-content sub-menu">
                      <li class="nav-item">
                        <router-link to='/calling-dashboard' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Bot Calling Dashboard </span></router-link>
                    </li>
                     <li class="nav-item">
                        <router-link to='/mydashboard' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics"> Auto Bot Analysis </span></router-link>
                    </li>
                  
                   
                </ul>
            </li> -->
               <!-- <li class="nav-item nav-item2">
                <a href="#/tracking-dashboard " aria-current="page" class="d-flex align-items-center">
                    <i  class="i_icon_st la-chalkboard-teacher las lab "></i>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Tracking Dashboard  </span>
                </a>
            </li> -->
            
             
          

            <!-- <li class="nav-item nav-item2">
                <a href="#/outbound/floor-plan-view" aria-current="page" class="d-flex align-items-center">
                    <i data-feather='layers' class="i_icon_st la-clipboard-list las lab "></i>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Floor Capacity</span>
                </a>
            </li> -->
             <li class="nav-item has-sub">
                <a href="#" aria-current="page" class="d-flex align-items-center first_a">
                    
                    <em class="i_icon_st las la-vector-square custom-class feather feather-settings"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Floor Capacity</span>
                </a>
                <ul class="menu-content sub-menu">
                    <li class="nav-item">
                        <router-link to='/outbound/floor-plan-view' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Outbound Floor Plan </span>
                    </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/inbound/floor-plan-view' class="d-flex align-items-center" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Inbound Floor Plan </span></router-link>
                    </li>
                </ul>
            </li>
            <li class="nav-item has-sub">
                <a href="#" aria-current="page" class="d-flex align-items-center first_a">
                    <em class="i_icon_st la-signal las lab"></em>
                    
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Fleet Management</span>
                </a>
                <ul class="menu-content sub-menu">
                    <li class="nav-item">
                        <router-link to='/fleet-dashboard' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Fleet Dashboard </span></router-link>
                    </li>
                   
                   
                    <li class="nav-item">
                        <router-link to='/live/vehicle/map-cluster' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics"> Live Vehicle Location </span></router-link>
                    </li>
                </ul>
            </li>
            <!-- <li class="nav-item nav-item2">
                <a href="https://localhost:4200/visualizer" target="_blank" aria-current="page" class="d-flex align-items-center">
                    <i data-feather='layers' class="i_icon_st la-clipboard-list las lab "></i>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Container Loading</span>
                </a>
            </li> -->
            <li class="nav-item has-sub">
                <a href="#" aria-current="page" class="d-flex align-items-center ">
                    <em class="i_icon_st las la-truck"></em>
                    
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Live Dock Status</span>
                </a>
                <ul class="menu-content sub-menu">
                    <li class="nav-item">
                        <router-link to='/live/dockSummaryView' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Loading </span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/live/unloadingSummaryView' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Unloading </span></router-link>
                    </li>
                </ul>
            </li>
            <li class="nav-item has-sub">
                <a href="#/mydashboard" aria-current="page" class="d-flex align-items-center first_a">
                    <!-- <em class="i_icon_st la-signal las lab"></em> -->
                    <em class="i_icon_st las la-chalkboard"></em>
                    
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Performance Dashboard</span>
                </a>
                <ul class="menu-content sub-menu">
                    <li class="nav-item">
                        <router-link to='/reports/analysis/gate-dock-performance' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics"> Global Performance </span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/reports/analysis/gate-in-out' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Gate Analysis </span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/reports/analysis/dock-in-out' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Dock Analysis </span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/reports/analysis/incentive' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Incentive </span></router-link>
                    </li>
                    
                </ul>
            </li>
            <li class="nav-item has-sub">
                <a href="#/mydashboard" aria-current="page" class="d-flex align-items-center first_a">
                    <!-- <em class="i_icon_st la-signal las lab"></em> -->
                    <em class="i_icon_st las la-industry"></em>
                    
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Reports</span>
                </a>
                <ul class="menu-content sub-menu">
                    <li class="nav-item">
                        <router-link to='/reports/analysis/toli-level-productivity' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Toli Level Productivity </span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/reports/analysis/vehicle-allocations' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Waiting Allocations</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/reports/analysis/pallet-scans' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Pallet Scans</span></router-link>
                    </li>
                </ul>
            </li>
             
            <li class="nav-item has-sub">
                <a href="#" aria-current="page" class="d-flex align-items-center first_a">
                    <!-- <em class="i_icon_st la-signal las lab"></em> -->
                    <em class="i_icon_st las la-user-check"></em>
                    
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Attendance Management</span>
                </a>
                <ul class="menu-content sub-menu">
                   
                    <li class="nav-item">
                        <router-link to='/attendance/attendance-regularise' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Attendance Regularise</span></router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to='/attendance/leave-apply' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Leave Apply</span></router-link>
                    </li>
                  
                </ul>
            </li>
            <li class="nav-item has-sub"  v-if="hasPermission('Access Control')">
                <a href="#" aria-current="page" class="d-flex align-items-center first_a">
                    <em class="las la-user-lock"></em>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Access Control</span>
                </a>
                <ul class="menu-content sub-menu">
                   <li class="nav-item" v-if="hasMenuPermission('Access Control','/access-control')">
                        <router-link to='/access-control' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Permissions</span></router-link>
                    </li>
                    <li class="nav-item" v-if="hasMenuPermission('Access Control','/register')">
                        <router-link to='/register' class="d-flex align-items-center navbar_mobile_inner_li" >
                        <em data-feather="circle"></em><span class="menu-item text-truncate rolelistdd" data-i18n="Analytics">Register</span></router-link>
                    </li>
                </ul>
            </li>
            <!-- </li>
               <li class="nav-item nav-item2">
                <a href="#/escalation-configuration" aria-current="page" class="d-flex align-items-center">
                    <i  class="i_icon_st la-chalkboard las lab "></i>
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Escalation  TAT Configuration </span>
                </a>
            </li> -->
            <!-- <li class="nav-item nav-item2">
                <a href="#/register" aria-current="page" class="d-flex align-items-center">
                    <i  class="i_icon_st las la-clipboard-list "></i>
                    
                    <span class="menu-title text-truncate rolelistdd" data-i18n="">Register User</span>
                </a>
            </li> -->

        </ul>
    </div>
</div>    
</template>

<script>
import { BoxIcon,PackageIcon,CheckCircleIcon,LifeBuoyIcon,HomeIcon,BriefcaseIcon,BookIcon,CodepenIcon,GridIcon,CalendarIcon,GlobeIcon,CreditCardIcon,FileIcon,SettingsIcon,LayersIcon,UsersIcon } from 'vue-feather-icons'

export default({
    name:'VMenu',
    components: {
        HomeIcon,
        BriefcaseIcon,
        BookIcon,
        CodepenIcon,
        GridIcon,
        CalendarIcon,
        BoxIcon,
        PackageIcon,
        CheckCircleIcon,
        LifeBuoyIcon,
        CreditCardIcon,
        GlobeIcon,
        FileIcon,SettingsIcon,LayersIcon,UsersIcon
    },
    data(){
        return{
            las:'las lab',
            currentindex:0,
            c:0,
            openFlag:false,
            navFlag:true,
            open:'open',
            nav_item:'nav-item',
            sidebarData: [],
            menuclass1:'dropdown-toggle d-flex align-items-center',
            menuclass:'d-flex align-items-center',
            menuActive:false,
            get_current_url:window.location.hash.trim(),
            controlTowerUsers: ['abhishek.khale@intellibees.com', 'nikhil@intellibees.in', 'atul.deokar@intellibees.com', 'Demo Control'],
            useremail: ""
        }
    },
    
    mounted(){
            var userdata = window.localStorage.getItem('userdata');
            // console.log(userdata)
            if(userdata) {
                userdata = JSON.parse(userdata)
                // console.log(userdata.username, "")
                this.useremail = userdata?userdata.username:null;
                // console.log(this.useremail, "++++")
            } else{
            this.$router.push({
                name: "Login_old"
            });
        }
         if (feather) {
            feather.replace({
                width: 14,
                height: 14
            });
        }
    },
    methods: {
        getIconForMenu(menuName) {
            return "las la-layer-group"
        },
        hasPermission(menuName) {
            return true
        },
        hasMenuPermission(menuName, subMenuRoutePath) {
            return true
        },
    }
    
    
    
})

</script>
<style>
.vertical-layout.vertical-menu-modern .main-menu .navigation li a .las{
    font-size: 1.65rem;
    margin-right: 0.7rem;
}
</style>
